import React, { useEffect, useState } from 'react';
import $ from 'jquery';

import {
    BusinessListLayout,
    CategoriesListLayout,
    Footer,
    Header
} from '../layouts';


import {
    Goto,
    Overlay,
    SearchBar,
    Spinner
} from '../components';
import { useDispatch } from 'react-redux';
// import { authActions } from '../store';
import { getCategFromTranslation } from '../helpers';




const Home = () => {
    const dispatch = useDispatch();

    const [loadPage, setLoadPage] = useState(true);
    // const [spinColor, setSpinColor] = useState("success");

    useEffect(() => {
        getCategFromTranslation(localStorage.getItem('i18nextLng') !== null ? { code: localStorage.getItem('i18nextLng') } : { code: "fr" }, dispatch);
        let tim2 = setTimeout(() => {
            setLoadPage(false);
        }, 100);

        return () => {
            clearTimeout(tim2);
        };
    }, [dispatch]);

    return <>

        {
            loadPage
                ? <>
                    <div style={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center',
                        height: '100vh',
                        width: '100%',
                        position: 'fixed',
                        left: 0,
                        top: 0,
                    }}>
                        <Spinner grow color={"success"} size={5} />

                    </div>

                </>
                : <GroupHome />
        }

        {/*<Helmet>*/}
        {/*    /!* <link href="https://fonts.googleapis.com/css2?family=Inter:wght@400;600&display=swap" rel="stylesheet" /> *!/*/}
        {/*    <title>African Business Network</title>*/}
        {/*    <link rel="stylesheet" href="./assets/css/bootstrap/icons/bootstrap-icons.css" />*/}
        {/*    <link rel="stylesheet" href="./assets/css/hs/mega-menu/mega-menu.min.css" />*/}
        {/*    <link rel="stylesheet" href="./assets/css/_theme.css" />*/}

        {/*    <script defer asyn src="./assets/js/bootstrap/bootstrap.bundle.min.js"></script>*/}
        {/*    <script defer asyn src="./assets/js/hs/go-to/goto.min.js"></script>*/}
        {/*    <script defer asyn src="./assets/js/prism/prism.js"></script>*/}
        {/*    <script defer asyn src="./assets/js/hs/show-animation/show-animation.min.js"></script>*/}
        {/*    <script defer asyn src="./assets/js/hs/mega-menu/mega-menu.min.js"></script>*/}
        {/*    <script defer asyn src="./assets/js/hs/header/header.min.js"></script>*/}
        {/*    <script defer asyn src="./assets/js/fslightbox/index.js"></script>*/}
        {/*    <script defer asyn src="./assets/js/theme.min.js"></script>*/}

        {/*</Helmet>*/}
    </>
}

export default Home;


const GroupHome = () => {

    useEffect(() => {
        const script = `
            new HSGoTo('.js-go-to');
            new HSHeader('#header').init();
            new HSMegaMenu('.js-mega-menu', {"desktop": {"position": "left"}});
        `;

        $('body').append(`<script className="homescript">${script}</script>`)

        return () => {
            $('.homescript').remove();
        };
    }, []);

    return <>
        <Overlay />
        <Header />

        <SearchBar />

        <BusinessListLayout />

        <CategoriesListLayout />
        <Goto />
        <Footer />
    </>
};